import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from "@fluentui/react";
import React from "react";
import { playgroundStyles as styles } from "../../Styles";
import { ScheduleDialogProps } from "../../Interfaces/PromptPlayground.interfaces";

export const ScheduleDialog: React.FC<ScheduleDialogProps> = ({
  isOpen,
  onClose,
  schedules,
  onSchedulesChange,
  onSave,
  isSaving,
  isSaved
}) => {
  const handleAddSchedule = () => {
    const newSchedule = { sessionName: "", frequency: "daily" as const, status: "active" as const };
    onSchedulesChange([...schedules, newSchedule]);
  };

  const handleDeleteSchedule = (index: number) => {
    const updated = schedules.filter((_, i) => i !== index);
    onSchedulesChange(updated);
  };

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onClose}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: "Update Schedules"
      }}
      minWidth={600}
    >
      <div>
        {schedules.map((schedule, index) => (
          <div key={`schedule-${index}`} style={{ display: "flex", gap: 10, marginBottom: 8 }}>
            <div>
              Schedule {index + 1}: {schedule.sessionName}
            </div>
            <button onClick={() => handleDeleteSchedule(index)}>Delete</button>
          </div>
        ))}
      </div>
      <DialogFooter>
        <PrimaryButton
          iconProps={{ iconName: "Add" }}
          onClick={handleAddSchedule}
          text="Add"
          styles={styles.buttonStyles}
        />
        <PrimaryButton
          iconProps={{ iconName: "Save" }}
          onClick={onSave}
          text={isSaved ? "Changes Saved" : "Save Changes"}
          disabled={isSaving || isSaved}
          styles={styles.buttonStyles}
        />
        <DefaultButton
          iconProps={{ iconName: "Cancel" }}
          onClick={onClose}
          text="Close"
          styles={styles.defaultButtonStyles}
        />
      </DialogFooter>
    </Dialog>
  );
};
